import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function formatCurrency(cents, currency = 'NZD') {
  const amount = Math.abs(cents) / 100;
  return new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

export default function BalanceChip({ balanceCents, currency = 'NZD', size = 'default' }) {
  const isPositive = balanceCents > 0;
  const isNegative = balanceCents < 0;
  const isZero = balanceCents === 0;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    default: 'px-3 py-1 text-sm gap-2',
    lg: 'px-4 py-1.5 text-base gap-2',
  };

  const iconSize = {
    sm: 'w-3 h-3',
    default: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  let className = `inline-flex items-center rounded-full font-medium font-mono border transition-colors ${sizeClasses[size]}`;
  let Icon = Minus;

  if (isPositive) {
    // Positive balance = client owes money (red) - show with "-" to indicate they owe
    className += ' bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20';
    Icon = TrendingUp;
  } else if (isNegative) {
    // Negative balance = client has credit (green)
    className += ' bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20';
    Icon = TrendingDown;
  } else {
    className += ' bg-muted text-muted-foreground border-border';
  }

  return (
    <span className={className} data-testid="balance-chip">
      <Icon className={iconSize[size]} />
      {isPositive && '-'}
      {formatCurrency(balanceCents, currency)}
    </span>
  );
}
